import React, { Component } from 'react';
import homedata from '../../data/homedata.json';

class FeatureTwo extends Component {
  render() {
   let publicUrl = process.env.PUBLIC_URL
   let imgattr = 'image'
   const data = this.props.data || homedata.feature2;

   // Check if we have values (value proposition structure)
   if (data.values) {
     return (
       <section id="feature2" className="p-80px-tb position-relative" style={{backgroundColor: 'white'}}>
          <div className="bordered-circle2"></div>
          <div className="container">
             <div className="row">
                <div className="col-md-12 text-center m-50px-b">
                   <h2 className="section-title font-weight-bold m-20px-b">{data.sectiontitle}</h2>
                   <h3 className="h4 text-primary">{data.subtitle}</h3>
                </div>
             </div>
             {data.values.map((value, index) => (
                <div key={index} className="row align-items-center m-50px-b">
                   <div className={`col-lg-6 ${index % 2 === 1 ? 'order-lg-2' : ''}`}>
                      <div className="value-content p-40px">
                         <div className="value-number display-1 font-weight-bold text-primary m-20px-b">
                            {value.number}
                         </div>
                         <h3 className="font-weight-bold m-25px-b">{value.title}</h3>
                         <p className="lead text-primary font-weight-bold m-20px-b">
                            {value.highlight}
                         </p>
                         <p className="text-muted">
                            {value.content}
                         </p>
                      </div>
                   </div>
                   <div className={`col-lg-6 ${index % 2 === 1 ? 'order-lg-1' : ''}`}>
                      <img
                         src={`${publicUrl}/assets/img/${index === 0 ? 'future.webp' : 'experience.png'}`}
                         alt={value.title}
                         className="img-fluid rounded"
                         style={{width: '100%', height: 'auto'}}
                      />
                   </div>
                </div>
             ))}
          </div>
       </section>
     );
   }

   // Original structure
    return (
      <section id="feature2" className="p-80px-tb sm-p-50px-tb featured-2 position-relative">
         <div className="bordered-circle2"></div>
         <div className="container">
            <div className="row">
               <div className="col-sm-6">
                  <h2>{data.title}</h2>
                  <p>{data.content}</p>
                  <div className="apps-buttons">
                     <a href={data.btn1url} className="btn btn-default btn-filled  animated-btn"><i className="icofont-brand-android-robot"></i> <span dangerouslySetInnerHTML={{__html: data.btn1label}}></span></a>
                     <a href={data.btn2url} className="btn btn-default  btn-filled animated-btn"><i className="icofont-brand-apple"></i> <span dangerouslySetInnerHTML={{__html: data.btn2label}}></span></a>
                  </div>
               </div>
               <div className="col-sm-6">
                  <div className="position-relative featured-mockup2">
                     <img className="phone-1" src={publicUrl+(data.imgurl1 || homedata.feature2.imgurl1)} alt={imgattr}/>
                     <img className="phone-2" src={publicUrl+(data.imgurl2 || homedata.feature2.imgurl2)} alt={imgattr}/>
                  </div>
               </div>
            </div>
         </div>
      </section>

    );
  }
}

export default FeatureTwo;
